import { service } from '@/utils/request'
const preApi = process.env.VUE_APP_ENV === 'development' ? '/dev' : ''
class qiniu {
  // 图片
  static getImageToken (params) { return service.get(`${preApi}/common/qiniu_qnp_grant_token`, { params }) }
  // 获取图片私域地址
  static getPrivateImageUrl (params) { return service.get(`${preApi}/common/qiniu_url_get_token`, { params }) }
  // 获取七牛没有没有校验
  static getImageTokenAdmin (params) { return service.get(`${preApi}/admCommon/qiniu_qnp_grant_token`, { params, headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'MAuthorization': '17e678193992071c98189c6c65bce2ca:' } }) }
}

export default qiniu
